"use strict";

var seed = 0;
module.exports = function guid() {
  return Date.now() + "_" + seed++;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/.3.4.1@rc-util/lib/guid.js
 ** module id = 510
 ** module chunks = 0
 **/